import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { NextPageContext } from 'next'
import Meta from 'components/modules/SEO/Meta'
import { trackEvent } from 'lib/tracking/analytics-service'
import { Container } from 'pages/chat'
import { StandardHeadline } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import NoFoundImage from 'assets/nothing_found.svg'
import { parseLocale } from 'lib/constants/localization'
import { AnalyticsEventWebServerError } from 'lib/constants/AnalyticsEventType'

function Error() {
    const { t } = useTranslation('common')

    return (
        <Container>
            <Meta title={t('common/pageNotFoundPageTitle')} description={t('common/pageNotFoundPageDescription')} noIndex />

            <StandardHeadline textAlign="center" color={theme.colors.actionGray}>
                {t('common/pageNotFoundPageTitle')}
            </StandardHeadline>

            <NoFoundImage />
        </Container>
    )
}

Error.getInitialProps = async ({ req, res, err, locale }: NextPageContext) => {
    const statusCode = res ? res.statusCode : err ? err.statusCode : 404
    trackEvent(AnalyticsEventWebServerError, {
        valueId: statusCode ? +statusCode : 0,
        value: `${req?.url}: ${err?.message}`,
        isServerSide: true,
    })

    return {
        ...(await serverSideTranslations(parseLocale(locale).interfaceLanguageCode, ['common', 'homepage'])),
    }
}

export default Error
